import React from "react";
import { ClockIcon, EditBtnIcon, EditIcon, EyeIcon, TrashIcon, EyeSlashIcon, LinkIcon } from "../../admin/Icons";
import { Space, Tooltip, Dropdown } from "antd";
import { black_color, blue_color, green_color, grey_color, orange_color, red_color, trimTrailingChar, tt_content_draft, tt_content_edit, tt_content_expired, tt_content_scheduled, tt_content_visible } from "../../utils/Utils";
import moment from "moment";

export default function ContentRow(props) {

  const { selected = false, setSelected = () => { }, content = {}, page_content = [], updateContent = () => { } } = props;

  const {
    page = 0,
    location = "",
    component = "",
    id = "",
    name = "",
    data = [],
    can_delete = true,
    container = false,
    visibility = "",
    expiry_action = false,
    start_date = null,
    end_date = null,
    date_created = 0,
    date_changed = 0

  } = content;

  const { path = "" } = props.page;


  const openLink = () => {
    let link = "";
    if (path) {
      link = trimTrailingChar(window.sitesettings.url, "/") + path + "#" + content.ee_id;
    }

    if (link) { window.open(link, "_blank"); return; }
  }

  const drawLink = () => {

    if (visibility !== "visible") {
      return (<></>)
    }

    return (
      <div style={{ "position": "relative", "top": "3px" }} >
        <Tooltip title={"Open URL to this component in a new tab"}>
          <LinkIcon onClick={() => openLink()} style={{ "color": blue_color }} />
        </Tooltip>
      </div>
    )
  }


  const drawClock = (start = start_date, end = end_date) => {
    let color;
    let tip = "";
    let format = "MMM Do, YYYY";
    const now = moment().unix();

    switch (true) {
      // Both Unset - don't draw
      case start === null && end === null:
        return;
      // One set
      case start === null && end > now:
        tip = "This content is live and will appear until " + moment(end * 1000).format(format);
        color = green_color; break;
      case start === null && end < now:
        tip = "This content was scheduled but expired on " + moment(end * 1000).format(format);
        color = red_color; break;
      case end === null && start > now:
        tip = "This content is scheduled to appear on " + moment(start * 1000).format(format);
        color = blue_color; break;
      case end === null && start < now:
        tip = "This content is live since " + moment(start * 1000).format(format) + " with no expiry set";
        color = green_color; break;
      // Both set
      case start < now && end > now:
        tip = "This content has been live since " + moment(start * 1000).format(format) + " and will appear until " + moment(end * 1000).format(format);
        color = green_color; break;
      case start < now && end < now:
        tip = "This content was scheduled but expired on " + moment(end * 1000).format(format);
        color = red_color; break;
      case start > now && end > now:
        tip = "This content is scheduled to appear between " + moment(start * 1000).format(format) + " and " + moment(end * 1000).format(format);
        color = blue_color; break;
      case start < now && end < now:
        tip = "This content was scheduled but expired on " + moment(end * 1000).format(format);
        color = red_color; break;
      default:
        color = blue_color; break;
    }

    return (<Tooltip title={<small>{tip}</small>}><ClockIcon style={{ "color": color }} /></Tooltip>)

  }

  const updateContentItem = (_val) => {

    let _content = [...page_content];
    let _index = _content.findIndex(item => item.id === id);
    _content[_index].visibility = _val;
    updateContent(_content);
  }

  let items = [

    { label: <div onClick={() => updateContentItem("visible")} style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div>, key: 'visible' },
  ];

  if (can_delete) {
    items.unshift({ label: <div onClick={() => updateContentItem("test")} style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div>, key: 'test' })
  }


  const drawVisibility = () => {
    let color;
    let tip;

    // export const tt_content_visible = <small>This content is visible to customers.</small>;
    // export const tt_content_draft = <small>This content is in draft mode, and is not visible to customers.</small>;
    // export const tt_content_scheduled = <small>This content is scheduled to appear between</small>
    // export const tt_content_expired = <small>This content was scheduled but expired on</small>


    switch (visibility) {
      case "visible":
        color = green_color;
        tip = tt_content_visible;
        return (<Dropdown trigger={['click']} menu={{ items }}><Tooltip title={tip}><EyeIcon style={{ "color": color }} /></Tooltip></Dropdown>)
        break;
      case "test":
        tip = tt_content_draft
        color = orange_color;
        return (<Dropdown trigger={['click']} menu={{ items }}><Tooltip title={tip}><EyeSlashIcon style={{ "color": color }} /></Tooltip></Dropdown>)
    }

  }




  return (
    <div className="float-flex">
      <div>{name}</div>
      <Space>
        {drawLink()}
        {drawClock()}
        {drawVisibility()}
        <div onClick={() => setSelected(id)}>
          <Tooltip title={tt_content_edit}><EditIcon style={{ "color": orange_color }} /></Tooltip>
        </div>

      </Space>
    </div>
  )
}